import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import 'mantine-datatable/styles.css';
import 'dayjs/locale/it';
import '@mantine/dates/styles.css';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { Center, Loader, MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';

import { useGetCurrentUserQuery } from '@api/auth.api';

import {
  selectIsLoadingAuthState,
  setCredentials,
  stopLoading,
} from '@slices/auth.slice';

import router from '@routes/router';

import theme from './theme';

export default function App() {
  const dispatch = useDispatch();

  const isLoading = useSelector(selectIsLoadingAuthState);

  const { data: user, isLoading: isLoadingGetUser } = useGetCurrentUserQuery();

  // Get user when page is reloaded
  useEffect(() => {
    if (!isLoadingGetUser) {
      if (user) {
        dispatch(setCredentials(user));
      } else {
        dispatch(stopLoading());
      }
    }
  }, [dispatch, user, isLoadingGetUser]);

  return (
    <MantineProvider theme={theme} defaultColorScheme="light">
      <Notifications />
      <DatesProvider settings={{ locale: 'it' }}>
        <ModalsProvider
          modalProps={{
            closeOnClickOutside: false,
          }}
        >
          {/* <GlobalSocketHandler /> */}
          {isLoading ? (
            <Center h="100vh">
              <Loader />
            </Center>
          ) : (
            <RouterProvider router={router} />
          )}
        </ModalsProvider>
      </DatesProvider>
    </MantineProvider>
  );
}
